module.exports = __webpack_public_path__ + "img/undraw_searching_p5ux.5863de27.svg";